export default {
    'user.name': 'Nombre de usuario',
    'user.placeHolder': 'Ingrese su nombre de usuario',
    'user.title': 'Usuario',
    'user.addUser': 'Crear usuario',
    'user.remark': 'Notas',
    'user.noUser': 'No ha creado ningún usuario.',
    'user.editUser': 'Editar usuario',
    'user.rule1': 'Reglas de configuración: La contraseña tiene entre 12 y 20 caracteres, admite letras, números y caracteres especiales, debe contener al menos uno de cada uno: mayúsculas, minúsculas, números y caracteres especiales.',
    'user.ruleTitle': 'Reglas de configuración:',
    'user.rule2': '1. El nombre de usuario tiene entre 3 y 20 caracteres, admite números y letras en inglés.',
    'user.rule3': '2. La contraseña tiene entre 12 y 20 caracteres, admite letras, números y caracteres especiales, debe contener al menos uno de cada uno: mayúsculas, minúsculas, números y caracteres especiales.',
    'user.passwordRule1': 'Este campo no puede quedar en blanco.',
    'user.passwordRule2': 'La contraseña debe tener entre 12 y 20 caracteres',
    'user.passwordRule3': 'Admite números y letras mayúsculas y minúsculas en inglés, y admite símbolos especiales.',
    'user.passwordRule4': 'La contraseña debe contener al menos una letra mayúscula',
    'user.passwordRule5': 'La contraseña debe contener al menos una letra minúscula',
    'user.passwordRule6': 'La contraseña debe contener al menos un número',
    'user.passwordRule7': 'La contraseña debe contener al menos un carácter especial',
    'user.usernameRule1': 'Este campo no puede quedar en blanco.',
    'user.usernameRule2': 'El nombre de usuario de 3 a 20 dígitos',
    'user.usernameRule3': 'Solo admite números y letras mayúsculas y minúsculas en inglés.',
    'user.delUserConfiem': '¿Estás seguro de que quieres eliminar este usuario?',
    'user.delUser': 'Eliminar usuarios',
    'user.edieUserTips': 'Por favor, tenga en cuenta:El robot necesita estar en línea para sincronizar la información del nuevo usuario. Si no puede iniciar sesión porque el robot no está conectado al Internet, primero puede iniciar sesión con la cuenta de administrador y conectar el robot a Internet.',
    'user.repeatUser': 'El nombre de usuario ya existe en la empresa, por favor, cámbielo.',
    'user.operator': 'Operador',
    'user.donotcontain': 'El nombre de usuario no puede contener símbolos especiales',
    'user.arearoom': 'Área/Habitación',
    'user.leave': '(izquierda)',
    'user.cong': 'Desde',
    'user.dao': 'Hasta',
    'user.adduser': 'Agregar operador',
    'user.createrdoperatoruser': 'El nuevo operador no tendrá autoridad para crear usuarios.',
    'user.userDisabled': 'Usuario desactivado, por favor, contacte al administrador',
    'user.jurisdiction': 'Permiso',
    'user.userstatus': 'Estado',
    'user.createduser': 'Acceso completo',
    'user.blockup': 'Desactivado',
    'user.recover': 'Restaurar',
    'user.normal': 'Activo',
    'user.RestoringaUser': 'Restaurar usuario',
    'user.recoveruser': '¿Estás seguro de que deseas restaurar este usuario?',
    'user.Successfulrecovery': 'Restaurado exitosamente',
    'user.failedrecovery': 'La recuperación falló',
    'user.notapplicableuser': '¿Está seguro de que quiere desactivar a este usuario? La cuenta está inactiva mientras esté desactivada, pero se puede usar una vez que se restaure el usuario.',
    'user.DeactivatingaUser': 'Desactivar usuario',
    'user.Deactivatingasuccessful': 'Desactivado con éxito',
    'user.Deactivatingafailed': 'Desactivación fallida',
    'user.timecalorders': 'Tiempo',
    'user.alphabeticalorder': 'Nombre',
    'user.blockuped': 'Desactivado',
    'user.email': 'Correo Electrónico',
    'user.emailRule1': 'Este campo no puede quedar en blanco',
    'user.emailRule2': 'Ingrese su correo electrónico en el formato correcto',
    'user.loginEmail': 'Correo Electrónico',
    'user.loginPassword': 'Nombre de Usuario',
    'email.placeHolder': 'Ingrese su correo electronico',
    'user.tipsemailexists': 'Este correo electrónico ya está en uso',
    'user.tipselseerror': 'Error no especificado',
    'user.tipsinterneterror': 'Error de red',
    'user.tipscreateemailsuccess': 'Se ha creado correctamente el usuario del buzón',
    'user.tipsverifycodeerror': 'Error al introducir el código de verificación',
    'user.tipsresendemail': 'El correo se ha reenviado',
    'user.emailrule1': 'Reglas de configuración: La contraseña tiene al menos 12 caracteres. Se permiten letras, números y caracteres especiales. Debe contener al menos 1 de cada uno: mayúsculas, minúsculas, números y caracteres especiales.',
    'user.emailrule2': '1. La contraseña tiene al menos 12 caracteres. Se permiten letras, números y caracteres especiales. Debe contener al menos 1 de cada uno: mayúsculas, minúsculas, números y caracteres especiales.',
    'user.resend': 'Reenviar',
    'user.complete': 'Completar',
    'user.emailregisttip': 'Introduzca el código de verificación recibido en su dirección de correo electrónico para completar el registro. Si no recibe el código de verificación, puede reenviarlo después de %ds.',
    'user.emailLogintip1': 'Hemos enviado un mensaje de confirmación a su dirección de correo electrónico. Por favor, introduzca el código de verificación recibido en el correo electrónico para verificar el inicio de sesión.',
    'user.emailLogintip2': 'Si no recibes el código de verificación, puedes reenviarlo después de %ds.',
    'user.noverifyday30': 'No verificado durante 30 días',
    'user.loginConfirm': 'Confirmar',
    'user.name_or_email': 'Nombre de usuario/Buzón',
    'user.name_or_email_placeholder': 'Introduzca el nombre de usuario/Buzón'
};
